// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInChangePasswordFormStyles } from "@awc/Overrides/Widgets/SignIn/SignInChangePasswordForm";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

signInChangePasswordFormStyles.form = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
signInChangePasswordFormStyles.userNameTextField =
    signInChangePasswordFormStyles.existingPasswordTextField =
    signInChangePasswordFormStyles.newPasswordTextField =
    signInChangePasswordFormStyles.confirmNewPasswordTextField =
        {
            cssOverrides: {
                formField: css`
                    justify-content: space-between;
                `,
            },
        };

signInChangePasswordFormStyles.changePasswordButton = {
    css: css`
        width: fit-content;
        align-self: end;
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};
